import CalendarItemNotificationManager from './CalendarItemNotificationManager';
import handleCalendarItemNotification from '../handlers/handleCalendarItemNotification';
import NotificationsQueue from './NotificationsQueue';

let notificationManager = null;
let notificationsQueue = null;

export function initNotificationManager() {
    notificationManager = new CalendarItemNotificationManager((folderId: string) =>
        handleCalendarItemNotification.bind(null, folderId)
    );
}

export default function getCalendarItemNotificationManager() {
    if (!notificationManager) {
        initNotificationManager();
    }
    return notificationManager;
}

export function initNotificationsQueue() {
    notificationsQueue = new NotificationsQueue();
}

export function getNotificationsQueue() {
    if (!notificationsQueue) {
        initNotificationsQueue();
    }
    return notificationsQueue;
}
